export const RECEIVE_CAREER_STATS = "RECEIVE_CAREER_STATS"
export const GET_CAREER_STATS = "GET_CAREER_STATS"

export const receiveCareerStats = (stats) => ({
  type: RECEIVE_CAREER_STATS,
  stats,
})

export const getCareerStats = (statType, success, error) => ({
  type: GET_CAREER_STATS,
  statType,
  success,
  error,
})
